import { EnvironmentConfiguration } from "../app/models/environment-configuration";

export const environment: EnvironmentConfiguration = {
  env_name: '#{ENV_NAME}#',
  production: false,
  enableConsoleLogging: false,

  apiUrl: '#{API_URL}#',
  webUrl : '#{WEB_URL}#',
  vobUrl : '#{VOB_URL}#',
  authUrl : '#{AUTH_URL}#',
  userAgreementUrl : '#{USER_AGREEMENT_URL}#',
  facilityWebUrl: '#{FACILITY_WEB_URL}#',
  executiveWebUrl: '#{EXECUTIVE_WEB_URL}#',
  reportingUrl: '#{REPORTING_URL}#',

  /* Microsoft SSO runs on the API (OpenID Connect); the SPA only needs to know whether to show the button. */
  ssoEnabled: true,
  cacheTimeInMinutes: 30,
  postLogoutUrl: '#{POST_LOGOUT_URL}#',
};
